module.exports = __webpack_public_path__ + "static/media/sign.c34c34af.jpg";